import { render, staticRenderFns } from "./BillingBatchHistoryModal.vue?vue&type=template&id=21c36670&scoped=true&"
import script from "./BillingBatchHistoryModal.vue?vue&type=script&lang=ts&"
export * from "./BillingBatchHistoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./BillingBatchHistoryModal.vue?vue&type=style&index=0&id=21c36670&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c36670",
  null
  
)

export default component.exports